<template>
  <img :src="logo">
</template>

<script>
import logoNewYear from '@/assets/images/logo/vasl-new-year.jpg'

export default {
  computed: {
    logo () {
      return logoNewYear
    }
  }
}
</script>

<style type="text/css" scoped>
.st0 {
  fill: #252369;
}
</style>
